import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { Notifications } from '@components/navigation/Notifications';
import { UserMenu } from '@components/navigation/UserMenu';
import { LuBell } from 'react-icons/lu';
import useNotificationStore from '@/stores/notificationStore';
import { DataStore } from '@/providers/dataStore/dataStore';
import { CommonUtils } from '@/helpers/commonUtils';
import { DATA_STORE_KEYS } from '@providers/dataStore';

export const Header = () => {
    const { notifications } = useNotificationStore();
    const userEmployeeData = DataStore.getItem(DATA_STORE_KEYS.USER_DATA);
    const roleNames =
        CommonUtils.jsonSafeParse(userEmployeeData)?.role?.map(role => role.roleName) || [];

    const handleRoleChange = event => {
        DataStore.setItem(DATA_STORE_KEYS.USER_CURRENT_ROLE, event.target.value);
        window.location.href = '/';
    };

    return (
        <header className="sticky top-0 z-[9] page-header shadow-card">
            <div className="page-header__logo">
                <img
                    src="https://www.quantanite.com/wp-content/uploads/2025/02/mobius_logo.png"
                    alt="logo"
                    className="h-full w-full object-contain"
                />
            </div>
            <NavigationMenu.Root className="NavigationMenuRoot">
                <NavigationMenu.List className="page-header__actions">
                    {roleNames && roleNames.length > 1 && (
                        <NavigationMenu.Item className="h-6">
                            <select
                                onChange={handleRoleChange}
                                className="capitalize px-2 py-1 rounded border border-gray-300"
                                value={DataStore.getItem(DATA_STORE_KEYS.USER_CURRENT_ROLE)}
                            >
                                {roleNames.map(role => (
                                    <option className="capitalize" key={role} value={role}>
                                        {role}
                                    </option>
                                ))}
                            </select>
                        </NavigationMenu.Item>
                    )}
                    <NavigationMenu.Item className="h-6">
                        <NavigationMenu.Trigger
                            className="page-header__actions__notification relative"
                            title="Notifications"
                            aria-label="Notifications"
                        >
                            <LuBell className="h-6 w-6" />
                            {notifications.length > 0 && (
                                <div className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></div>
                            )}
                        </NavigationMenu.Trigger>
                        <Notifications />
                    </NavigationMenu.Item>
                    <UserMenu />
                </NavigationMenu.List>
            </NavigationMenu.Root>
        </header>
    );
};
